import {
  DSCardWrapper,
  DSInput,
  DSTextarea,
  DSToggle,
} from "@components/design-system/molecules";
import { faCircleQuestion } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Controller, useWatch } from "react-hook-form";

import { RequiredAsterisk } from "../../../../common/RequiredAsterisk";
import { DEFAULT_TEMPLATE_EXAMPLES } from "../../../constants";
import FavoriteToggle from "../../../FavoriteToggle";
import ChooseTemplateType from "../ChooseTemplateType";

const MetadataSection = ({ handleTemplateTypeChange, control }) => {
  const formData = useWatch({ control });
  const { releaseWebDentalChartToggle } = useFlags();
  return (
    <DSCardWrapper
      variant="default"
      padding="p-md"
      dataTestId="metadata-section"
    >
      <div id="template-details">
        <div className="relative flex items-center mb-md">
          <div className="w-full">
            <label
              htmlFor="name"
              className="block text-sm font-semibold text-primary mb-1"
            >
              Name <RequiredAsterisk />
            </label>
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <DSInput
                  type="text"
                  id="name"
                  name="name"
                  dataTestId="template-name-input"
                  placeholder={
                    formData?.templateType === "SOAP"
                      ? DEFAULT_TEMPLATE_EXAMPLES.SOAP.name
                      : DEFAULT_TEMPLATE_EXAMPLES.CUSTOM.name
                  }
                  value={formData?.name}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  required
                />
              )}
            />
          </div>
          <div className="absolute -top-1 right-1">
            <FavoriteToggle control={control} />
          </div>
        </div>
        {/* Description */}
        <div className="mb-md">
          <Controller
            control={control}
            name="description"
            render={({ field }) => (
              <DSTextarea
                id="description"
                name="description"
                label="Description"
                dataTestId="template-description-input"
                minRows={2}
                placeholder={
                  formData?.templateType === "SOAP"
                    ? DEFAULT_TEMPLATE_EXAMPLES.SOAP.description
                    : DEFAULT_TEMPLATE_EXAMPLES.CUSTOM.description
                }
                value={field.value}
                onChange={(e) => {
                  field.onChange(e);
                }}
              />
            )}
          />
        </div>

        <ChooseTemplateType
          handleTemplateTypeChange={handleTemplateTypeChange}
          formData={formData}
          belowFreeform={
            formData?.templateType === "CUSTOM" &&
            releaseWebDentalChartToggle ? (
              <div className="flex items-center space-x-3">
                <Controller
                  control={control}
                  name="dentalChart"
                  render={({ field }) => (
                    <DSToggle
                      checked={field.value ?? false}
                      onChange={(e) =>
                        field.onChange(e.target.checked)
                      }
                      dataTestId="dental-chart-toggle"
                      aria-label="Add Dental Chart"
                    />
                  )}
                />
                <label className="font-semibold flex items-center gap-1.5">
                  Add Dental Chart 🦷
                  <Tooltip
                    title="Note will generate with a visual dental chart."
                    arrow
                  >
                    <span className="cursor-default text-secondary">
                      <FontAwesomeIcon
                        icon={faCircleQuestion}
                        className="text-xs"
                      />
                    </span>
                  </Tooltip>
                </label>
              </div>
            ) : undefined
          }
        />
      </div>
    </DSCardWrapper>
  );
};

export default MetadataSection;
